import { render } from "./AppointmentScheduler.vue?vue&type=template&id=3c8fce41&scoped=true"
import script from "./AppointmentScheduler.vue?vue&type=script&lang=js"
export * from "./AppointmentScheduler.vue?vue&type=script&lang=js"

import "./AppointmentScheduler.vue?vue&type=style&index=0&id=3c8fce41&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c8fce41"]])

export default __exports__